import { ReactElement } from "react"

import AmendEVDCDeviceForm from "../../../../components/devices/lct/evdc/amendEVDCDeviceForm"
import NewEVDCDeviceAmendmentProvider from "../../../../components/devices/lct/evdc/providers/newEVDCDeviceAmendmentProvider"

/** Root webpage for amending an EVDC device */
const AmendEVDCDevice = (): ReactElement => (
    <NewEVDCDeviceAmendmentProvider>
        <AmendEVDCDeviceForm />
    </NewEVDCDeviceAmendmentProvider>
)

export default AmendEVDCDevice
